/* Recently viewed products (localStorage) */
(function () {
  'use strict';
  const KEY = 'shanium_recently_viewed';
  const MAX = 8;
  const productHandle = document.body.dataset.productHandle;
  if (productHandle) {
    let list = JSON.parse(localStorage.getItem(KEY) || '[]');
    list = [productHandle, ...list.filter((h) => h !== productHandle)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  const container = document.querySelector('[data-recently-viewed]');
  if (!container) return;
  const list = JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => h !== productHandle);
  if (!list.length) { container.hidden = true; return; }
  container.hidden = false;
  Promise.all(list.slice(0, 4).map((h) =>
    fetch(`/products/${h}.js`).then((r) => r.ok ? r.json() : null).catch(() => null)
  )).then((products) => {
    const grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    grid.innerHTML = products.filter(Boolean).map((p) => `
      <a class="product-card" href="${p.url}">
        <div class="product-card__media">
          <img src="${(p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_600x$1$2')}" alt="${p.title}" loading="lazy">
        </div>
        <h3 class="product-card__title">${p.title}</h3>
        <p class="product-card__price">${(p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify?.currency?.active) || 'INR' })}</p>
      </a>
    `).join('');
  });
})();
